import React, { PureComponent } from "react";
import s from "./backLink.scss";
import TranslatedString from "Components/TranslatedString";
import { Icon /*leftFill*/ } from "Icons/index";

export default class BackLink extends PureComponent {
  render() {
    let text = this.props.text;
    if (!text) {
      text = <TranslatedString>action.goBackToList</TranslatedString>;
    }

    return (
      <span className={s.backLink} onClick={this.props.onClick}>
        <Icon svg={leftFill} width="10px" height="10px" color="#222E3D" />
        {text}
      </span>
    );
  }
}
